// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fddce166","453":"96453769","499":"6123aa5d","571":"f8b7d887","654":"0d228e45","903":"8dd5cff7"}[chunkId] + ".chunk.js";
};